<template>
  <section id="legal-writing-view">
    <template v-if="authUser && session && authUser.id === session.tutor_id">
      <v-container fluid v-if="session.mock">
        <v-card>
          <v-toolbar dense dark color="primary">
            Candidate instructions
            <v-spacer/>
            <v-btn icon @click="show_instruction = !show_instruction">
              <v-icon v-if="show_instruction">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
          </v-toolbar>

          <v-sheet class="overflow-y-auto" max-height="500px">
            <v-card-text class="ql-editor" v-if="session.mock.instruction && show_instruction" v-html="session.mock.instruction.body"></v-card-text>
          </v-sheet>

        </v-card>
      </v-container>

      <v-container fluid v-if="session.mock && session.mock.materials">
        <materials-viewer :items="session.mock.materials"></materials-viewer>
      </v-container>

      <v-container fluid>
        <v-card>
          <v-toolbar dense dark color="primary">Candidate's answer</v-toolbar>
          <v-divider/>

          <template v-for="(answer, idx) in answers">
            <div class="" :key="idx">
              <template v-if="answer.type === 'google_doc'">
                <v-list-item :disabled="!answer.google_view_link" :href="answer.google_view_link" target="_blank">
                  <v-list-item-avatar tile size="50">
                    <img :src="`/img/google/${getIcon(answer)}.png`" alt="">
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ answer.name }}</v-list-item-title>
                  </v-list-item-content>

                  <v-btn small color="success" target="_blank"
                         :disabled="!answer.google_view_link"
                         :href="answer.google_view_link">
                    <v-icon>mdi-link</v-icon>

                    open
                  </v-btn>
                </v-list-item>
              </template>
              <template v-else>
                <v-toolbar dense flat class="blur" outlined>
                  {{ answer.name }}
                </v-toolbar>
                <vue-editor v-model="answer.body" :editor-toolbar="toolbar" @input="debounceUpdateAnswer(answer)"/>
              </template>
            </div>
          </template>
        </v-card>
      </v-container>
    </template>

    <template v-if="authUser && session && authUser.id === session.user_id">
      <v-container fluid>
        <v-card class="mb-3">
          <v-toolbar dark dense color="primary">
            Instructions
            <v-spacer/>
            <v-btn icon @click="show_instruction =! show_instruction">
              <v-icon v-if="show_instruction">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
          </v-toolbar>
          <template v-if="show_instruction">
            <v-sheet v-if="session.mock.instruction" class="overflow-y-auto unselectable" max-height="500px">
              <v-card-text class="ql-editor" v-html="session.mock.instruction.body"></v-card-text>
            </v-sheet>
            <v-sheet v-else class="overflow-y-auto" max-height="500px">
              <v-card-text>No data available</v-card-text>
            </v-sheet>
          </template>
        </v-card>
      </v-container>

      <v-container fluid v-if="session.mock && session.mock.materials">
        <materials-viewer :items="session.mock.materials"></materials-viewer>
      </v-container>

      <v-container fluid>
        <v-card class="mb-6">
          <v-toolbar dark dense color="primary">
            Your answers
            <v-spacer/>
<!--            <v-btn v-if="!session.ready" small color="success box-shadow" @click="openNewAnswerDialog">Add new</v-btn>-->
          </v-toolbar>

          <template v-if="!session.ready" >
            <template v-for="(answer, idx) in answers">
<!--              TODO show answer-->
              <div class="" :key="idx">
                <template v-if="answer.type === 'google_doc'">
                  <v-list-item :disabled="!answer.google_view_link" :href="answer.google_view_link" target="_blank">
                    <v-list-item-avatar tile size="50">
                      <img :src="`/img/google/${getIcon(answer)}.png`" alt="">
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ answer.name }}</v-list-item-title>
                    </v-list-item-content>

                    <v-btn small color="success" target="_blank"
                           :disabled="!answer.google_view_link"
                           :href="answer.google_view_link">
                      <v-icon>mdi-link</v-icon>

                      open
                    </v-btn>
                  </v-list-item>
                </template>

                <template v-else>
                  <v-toolbar dense flat class="blur" outlined>
                    {{answer.name }}
                    <v-spacer/>
                    <v-btn color="red" small @click="deleteAnswer(answer)">Delete</v-btn>
                  </v-toolbar>
                  <vue-editor v-model="answer.body" :editor-toolbar="toolbar" @input="debounceUpdateAnswer(answer)"/>
                </template>
              </div>
            </template>

            <template v-if="new_answer_dialog">
              <v-card-text>
                <v-text-field v-model="new_answer.name" label="Title (optional)" hide-details solo-inverted></v-text-field>
              </v-card-text>
              <vue-editor v-model="new_answer.body" :editor-toolbar="toolbar" />
              <v-card-actions>
                <v-btn text @click="closeNewAnswerDialog">cancel</v-btn>
                <v-spacer/>
                <v-btn color="primary" @click="createNewAnswer">create</v-btn>
              </v-card-actions>
            </template>

            <v-card>
              <v-list-item>
                <v-list-item-icon><v-icon>mdi-school</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    Before you click Submit, please make sure your assignment is fully completed. No edits can be made after submission.
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn color="primary" @click="mark_session_ready_dialog =!mark_session_ready_dialog">Submit for marking</v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-card>
          </template>

          <template v-if="session.ready">
            <template v-for="(answer, idx) in answers">
              <!--              TODO show answer-->
              <div class="" :key="idx">
                <template v-if="answer.type === 'google_doc'">
                  <v-list-item :disabled="!answer.google_view_link" :href="answer.google_view_link" target="_blank">
                    <v-list-item-avatar tile size="50">
                      <img :src="`/img/google/${getIcon(answer)}.png`" alt="">
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ answer.name }}</v-list-item-title>
                    </v-list-item-content>

                    <v-btn small color="success" target="_blank"
                           :disabled="!answer.google_view_link"
                           :href="answer.google_view_link">
                      <v-icon>mdi-link</v-icon>

                      open
                    </v-btn>
                  </v-list-item>
                </template>

                <template v-else>
                  <v-toolbar dense flat class="blur" outlined>
                    {{answer.name }}
                    <v-spacer/>
                  </v-toolbar>
                  <v-card-text class="ql-editor" v-html="answer.body"></v-card-text>                </template>
              </div>
            </template>
          </template>
        </v-card>

        <template v-if="session.marked">
          <v-card class="unselectable">
            <template v-if="session.review">
              <v-toolbar dense color="blur">Review</v-toolbar>
              <v-sheet class="overflow-y-auto" min-height="200px" max-height="400px">
                <v-card-text class="ql-editor" v-html="session.review"></v-card-text>
              </v-sheet>
            </template>

            <v-toolbar dense color="blur">
              Marks
              <v-spacer/>
              Final mark <v-chip label color="primary px-2 mx-1">{{ session.final_mark}}</v-chip>
            </v-toolbar>
            <v-data-iterator :items="session.marks"
                             disable-pagination
                             disable-filtering
                             hide-default-footer
            >
              <template v-slot:default="props">
                <v-row>
                  <v-col cols="12" md="6" class="p-0" v-for="(category, idx) in props.items" :key="idx">
                    <v-card flat>
                      <v-card-title> {{ category.name }} <v-spacer/>
                        <v-chip label color="primary px-2 mx-1">{{ category.value }}</v-chip></v-card-title>
                      <v-divider/>
                      <v-list-item v-for="(sub_category, i) in category.children" :key="i">
                        <v-list-item-content v-text="sub_category.name"/>
                        <v-list-item-action v-text="sub_category.value"/>
                      </v-list-item>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-card>
        </template>

      </v-container>

      <v-dialog v-model="mark_session_ready_dialog" max-width="500px">
        <v-card>
          <v-toolbar dense dark color="error">Submit for grading</v-toolbar>
          <v-card-text class="pt-3">
            Before you click Submit, please make sure your assignment is fully completed. No edits can be made after submission.
          </v-card-text>
          <v-divider/>
          <v-card-actions class="justify-space-between">
            <v-btn text @click="mark_session_ready_dialog =!mark_session_ready_dialog">Cancel</v-btn>
            <v-btn color="primary" @click="markSessionReadyForGrading">
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </section>
</template>

<script>

import _ from "lodash";

export default {
  components: {
  },
  props: {
    session: {
      type: Object,
      default: null
    }
  },
  data: () => ({

    show_instruction: true,
    show_materials: true,
    answers: [],
    files: [],
    rules: [
      files => !files || !files.some(file => file.size > 2_097_152) || 'File size should be less than 2 MB!'
    ],
    mark_session_ready_dialog: false,

    api_errors: [],


    toolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }, "bold", "italic", "underline"],
      [{align:""}, {align:"center"}, {align:"right"}, {align:"justify"}],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: []}],
      ["blockquote", "code-block"],
      ["link", "image", "formula"],
    ],
    stepper: 1,
    mark_options: [
      {text: 'Good', value: 'good'},
      {text: 'Check', value: 'check'},
      {text: 'Plus', value: 'plus'},
      {text: '50/50', value: '50_50'},
      {text: 'Minus', value: 'minus'},
    ],

    new_answer: null,
    new_answer_dialog: false,

    mimetypes: [
      {value: 'application/vnd.google-apps.document', text: 'Document', icon: 'document'},
      {value: 'application/vnd.google-apps.drawing', text: 'Drawing', icon: 'drawing'},
      {value: 'application/vnd.google-apps.form', text: 'Form', icon: 'form'},
      {value: 'application/vnd.google-apps.presentation', text: 'Presentation', icon: 'presentation'},
      {value: 'application/vnd.google-apps.spreadsheet', text: 'Sheets', icon: 'spreadsheet'},
      // {value: 'application/vnd.google-apps.photo', text: 'Photo', icon: 'photo'},
      // {value: 'application/vnd.google-apps.video', text: 'video', icon: 'video'},
    ],
  }),
  mounted() {
    this.loadAnswers()
  },
  methods: {
    loadAnswers() {
      this.axios.get(`api/user/sessions/${this.$route.params.session_id}/answers`)
          .then(({data}) => { this.answers = data.data })
    },
    getIcon(document) {
      if(document.google_mimetype) {
        let mimetype = this.mimetypes.find(item => item.value === document.google_mimetype)
        if(mimetype) return mimetype.icon
      }
      return null
    },
    openNewAnswerDialog() {
      this.new_answer = {
        type: 'text',
        name: '',
        body: ''
      }
      this.new_answer_dialog = true
    },
    closeNewAnswerDialog() {
      this.new_answer_dialog = false
      this.new_answer = null
    },
    createNewAnswer() {
      this.app_loading = true
      this.axios.post(`api/user/sessions/${this.$route.params.session_id}/answers/text`, this.new_answer)
        .then(({data}) => {
          this.answers.push(data.data)
          this.closeNewAnswerDialog()
        })
        .catch(errors => {console.log(errors)})
        .then(() => {this.app_loading = false})
    },
    updateAnswer(item) {
      this.axios.put(`api/user/sessions/${this.$route.params.session_id}/answers/${item.id}`, item)
    },
    debounceUpdateAnswer:_.debounce(function (item) {this.updateAnswer(item)}, 2000),

    pushNewAnswer(answer) {
      this.answers.push(answer)
    },
    deleteAnswer(item) {
      this.app_loading = true
      this.axios.delete(`api/user/sessions/${this.$route.params.session_id}/answers/${item.id}`)
          .then(() => {
            this.loadAnswers()
            this.app_loading = false
          })
    },
    markSessionReadyForGrading() {
      this.$emit('sessionReady')
      this.mark_session_ready_dialog = !this.mark_session_ready_dialog
    },
  }
}
</script>
